export default __webpack_public_path__ + "static/media/KnurlingImg.7ef8dbe1.jpg";